import Vue from 'vue';
import VueRouter from 'vue-router';

import store from '@/store/index';

import { BASE_ENTER_SCENE } from '@/store/mutation-types.js';
import bridge_handler from '@utils/bridge';

import { insureRoute } from './insureRoute';
import { dqRoutes } from './dqRoute';
import billSignRoutes from './billSignRoutes';
import outInRoutes from './outIntCard';

Vue.use(VueRouter);

const mainRoutes = [
  {
    path: '/',
    redirect: '/auth',
  },
  {
    path: '/auth/:module',
    name: 'auth',
    meta: { title: '' },
    component: () =>
      import(/* webpackChunkName: "auth" */ '../views/Auth/index'),
  },
  {
    path: '/wxAuth/:module',
    name: 'wxAuth',
    meta: { title: '' },
    component: () =>
      import(/* webpackChunkName: "auth" */ '../views/Auth/wxAuth'),
  },
  {
    path: '/not-found',
    name: 'not-found',
    meta: { title: '404' },
    component: () =>
      import(/* webpackChunkName: "auth" */ '../views/Auth/NotFound'),
  },
  {
    path: '/no-power',
    name: 'no-power',
    meta: { title: '403' },
    component: () =>
      import(/* webpackChunkName: "auth" */ '../views/Auth/NoPower'),
  },
  {
    path: '/agreement',
    name: 'agreement',
    meta: { title: '协议', authWhite: true },
    component: () =>
      import(/* webpackChunkName: "agreement" */ '../views/Agreement/index'),
  },
  {
    path: '/download',
    name: 'download',
    meta: { title: '万商服' },
    component: () =>
      import(/* webpackChunkName: "agreement" */ '../views/Download/index'),
  },
  {
    path: '/bulletin',
    name: 'bulletin',
    meta: { title: '公告' },
    component: () =>
      import(/* webpackChunkName: "bulletin" */ '../views/Bulletin/index'),
  },
  {
    path: '/question',
    name: 'question',
    meta: { title: '调查问卷' },
    component: () =>
      import(/* webpackChunkName: "question" */ '../views/Questionnaire/index'),
  },
  {
    path: '/question/fallback',
    name: 'questionFallback',
    meta: { title: '问卷状态' },
    component: () =>
      import(
        /* webpackChunkName: "question" */ '../views/Questionnaire/Fallback'
      ),
  },
  // 广场活动
  {
    path: '/plaza/activity/home',
    name: 'plazaActivity',
    meta: { title: '广场活动' },
    component: () =>
      import(/* webpackChunkName: "activity" */ '../views/PlazaActivity/Home'),
  },
  // 广场活动-详情
  {
    path: '/plaza/activity/detail',
    name: 'plazaActivityDetail',
    meta: { title: '活动详情' },
    component: () =>
      import(
        /* webpackChunkName: "activity" */ '../views/PlazaActivity/Detail'
      ),
  },
  // {
  //   path: '/plaza/activity/detail',
  //   name: 'activity',
  //   meta: { title: '活动详情' },
  //   component: () =>
  //     import(/* webpackChunkName: "activity" */ '../views/PlazaActivity/Detail'),
  // },
  // 广场活动-报名
  {
    path: '/plaza/activity/reg',
    name: 'plazaActivityReg',
    meta: { title: '活动报名' },
    component: () =>
      import(
        /* webpackChunkName: "activity" */ '../views/PlazaActivity/Register'
      ),
  },
  // 员工餐(?type=food)、内购会(?type=discount),默认food
  {
    path: '/plaza/activity/inside',
    name: 'plazaActivityInside',
    meta: { title: '商户活动' },
    component: () =>
      import(
        /* webpackChunkName: "activity" */ '../views/PlazaActivity/Inside'
      ),
  },
  // 员工餐、内购会-详情
  {
    path: '/plaza/activity/inside/:id',
    name: 'plazaActivityInsideDetail',
    meta: { title: '活动详情', isShowOrHiddenRightBtn: 1 },
    component: () =>
      import(
        /* webpackChunkName: "activity" */ '../views/PlazaActivity/InsideDetail'
      ),
  },
  {
    path: '/study',
    name: 'study',
    meta: { title: '同业分享' },
    component: () =>
      import(/* webpackChunkName: "study" */ '../views/Study/index'),
  },
  {
    path: '/manual',
    name: 'manual',
    meta: { title: '操作手册' },
    component: () =>
      import(/* webpackChunkName: "study" */ '../views/Study/index'),
  },
  {
    path: '/communication',
    name: 'communication',
    meta: { title: '商户沟通会' },
    redirect: '/communication/form',
    component: () =>
      import(
        /* webpackChunkName: "communication" */ '../views/Communication/index'
      ),
    children: [
      {
        path: '/communication/form',
        name: 'communication-form',
        meta: {
          title: '商户沟通会',
          index: 0,
        },
        component: () =>
          import(
            /* webpackChunkName: "communication" */ '../views/Communication/Form'
          ),
      },
      {
        path: '/communication/error',
        name: 'communication-error',
        meta: {
          title: '商户沟通会',
          index: 0,
        },
        component: () =>
          import(
            /* webpackChunkName: "communication" */ '../views/Communication/Error'
          ),
      },
      {
        path: '/communication/evaluate',
        name: 'communication-evaluate',
        meta: { title: '问题处理评价', index: 1 },
        component: () =>
          import(
            /* webpackChunkName: "communication" */ '../views/Communication/Evaluate'
          ),
      },
    ],
  },
  {
    path: '/utils-img',
    name: 'utils-img',
    meta: { title: '' },
    component: () =>
      import(/* webpackChunkName: "utils" */ '../views/Utils/Img'),
  },
  {
    path: '/accusation',
    name: 'accusation',
    meta: { title: '举报' },
    component: () =>
      import(/* webpackChunkName: "accusation" */ '../views/Accusation/index'),
  },
  {
    path: '/insurance',
    name: 'insuranceDe',
    meta: { title: '保险购买' },
    component: () =>
      import(/* webpackChunkName: "safety" */ '../views/Insurance/index'),
  },
  {
    path: '/insurance/detail',
    name: 'insuranceDetail',
    meta: { title: '保险详情' },
    component: () =>
      import(/* webpackChunkName: "safety" */ '../views/Insurance/detail'),
  },
  {
    path: '/demo/home',
    name: 'Home',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/demo/Home.vue'),
  },
  {
    path: '/demo/granary',
    name: 'Granary',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/demo/granary.vue'),
  },
  {
    path: '/demo/rightsList',
    name: 'RightsList',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/demo/rightsList.vue'),
  },
  {
    path: '/demo/index',
    name: 'Index',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/demo/index.vue'),
  },
  // 万达广场商户交流分享满意度调查
  {
    path: '/share/suggest',
    name: 'suggest',
    meta: { title: '万达广场商户交流分享满意度调查' },
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/ShareSuggest/index.vue'),
  },

  // 增值服务
  {
    path: '/service/addService',
    name: 'addService',
    meta: { title: '增值服务' },
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/AddService/addService.vue'),
  },
];
import { knowledgeBaseRoutes } from './knowledgeBaseRoutes';
import niceProperty from './niceProperty'

export const routes = mainRoutes.concat(dqRoutes).concat(knowledgeBaseRoutes).concat(billSignRoutes).concat(insureRoute).concat(outInRoutes).concat(niceProperty);



const router = new VueRouter({
  routes,
});

export default router;

router.beforeEach((to, from, next) => {
  // let weChatOfficialAccountType = to.query.weChatOfficialAccountType || from.query.weChatOfficialAccountType

  if(to.path.includes('dq_auth')){
    let latitude = to.query.latitude || ''
    localStorage.setItem('latitude',latitude)
  }
  // if(weChatOfficialAccountType){
  //   localStorage.setItem('weChatOfficialAccountType',weChatOfficialAccountType)
  // }
  if (to.query['BASE_ENTER_SCENE']) {
    store.commit(`base/${BASE_ENTER_SCENE}`, to.query['scene']);
  }
  document.title = to.meta.title;

  if (to.name != 'accusation') {
    if (to.meta.isShowOrHiddenNavBar === 0) {
      bridge_handler &&
        bridge_handler.callBridge &&
        bridge_handler.isShowOrHiddenNavBar('0');
    } else {
      bridge_handler &&
        bridge_handler.callBridge &&
        bridge_handler.isShowOrHiddenNavBar('1');
    }

    // eslint-disable-next-line no-prototype-builtins
    const isShowOrHiddenRightBtn = to.params.hasOwnProperty(
      'isShowOrHiddenRightBtn'
    )
      ? to.params.isShowOrHiddenRightBtn
      : '0';
    bridge_handler.callBridge &&
      bridge_handler.isShowOrHiddenRightBtn({ isShow: isShowOrHiddenRightBtn });
  }

  next();
});
